export default __webpack_public_path__ + "img/78a75eefd64a75f496120ac1742eef0f.svg";